import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core';
import HotelForm from '../HotelForm';
import { useQuery, useMutation } from '@apollo/client';
import { GET_HOTEL, GET_HOTELS } from '../graphql/queries';
import { UPDATE_HOTEL } from '../graphql/mutations';
import useNotifications from '../../../Notifications/useNotifications';
import useHandleAuthError from '../../../utils/hooks/useHandleAuthError';
import { HotelInput } from '../HotelForm/types';
import { useNavigate, useParams } from 'react-router';

const EditHotel: FC = () => {
  const onError = useHandleAuthError();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { addSuccess, addError } = useNotifications();

  const { loading, data } = useQuery(GET_HOTEL, {
    variables: { id },
    onError
  });

  const [updateHotel] = useMutation(UPDATE_HOTEL, {
    onCompleted: () => {
      addSuccess('Hotel updated successfully.');
      navigate(`/hotels/details/${id}`);
    },
    onError: () => addError('Error updating hotel. Please try again.'),
    refetchQueries: [{ query: GET_HOTEL, variables: { id } }, { query: GET_HOTELS }],
    awaitRefetchQueries: true
  });

  const onSubmit = (values: HotelInput) =>
    updateHotel({
      variables: {
        id,
        values: {
          name: values.name,
          phone: values.phone,
          address: values.address
        }
      }
    });

  if (loading) {
    return <div>Loading</div>;
  }

  if (data && data.hotel) {
    return (
      <>
        <h1 className="my-6 text-3xl">Edit hotel</h1>
        <HotelForm onSubmit={onSubmit} initialValues={data.hotel} />
      </>
    );
  }

  return <div>{null}</div>;
};

export default EditHotel;
